export default function ThreeD() {
  return (
    <svg width="81" height="51" viewBox="0 0 91 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_31_192)">
        <path d="M37.5498 13.9434C29.4559 8.16005 22.8697 16.0824 23.8219 21.0735C16.8465 24.793 20.4811 33.5717 26.2628 33.5909H58.8163C68.3385 31.4518 65.4025 21.6281 59.7685 20.519C60.7207 3.88193 41.3587 3.72349 37.5498 13.9434Z" fill="white" />
      </g>
      <defs>
        <filter id="filter0_d_31_192" x="0" y="0" width="69" height="50.5908" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="-8" dy="5" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.00799999 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_31_192" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_31_192" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}
